import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react';
import { breakpoints } from '@/layouts/breakpoints'

const providers = [
  {
    name: 'AVM',
    cta: 'Azure',
    subtitle: 'Microsoft Azure',
    icon: '/devs/microsoft-azure.svg',
    href: '/developers/libraries',
  },
  {
    name: 'EC2',
    cta: 'AWS',
    subtitle: 'Amazon Web Services',
    icon: '/devs/aws.svg',
    href: '/developers/libraries',
  },
  {
    name: 'Compute Engine',
    cta: 'GCP',
    subtitle: 'Google Cloud Platform',
    icon: '/devs/google-cloud.svg',
    href: '/developers/libraries',
  },
];

const StyledComp = styled.section`
  background: #ffffff;
  padding: 120px 40px;
  text-align: center;
  width: calc(100% - 80px);
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: ${breakpoints.medium}) {
    padding: 40px;
  }
  .heading {
    font-size: 36px;
    margin: 0 0 12px;
  }

  .subheading {
    font-size: 12px;
    line-height: 1.5;
    color: var(--grey);
    max-width: 480px;
    margin: 0 auto 48px;
  }

  .card-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    min-width: 100%;
    gap: 24px;
    max-width: 980px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    .card-grid {
      grid-template-columns: 1fr;
    }
  }

  .card {
    border: 1px solid #ececec;
    border-radius: 8px;
    padding: 40px 24px 28px;
    text-align: center;
  }

  .card-icon {
    width: 40px;
    height: 40px;
    margin: 0 auto 20px;
    display: block;
  }

  .card-title {
    font-size: 17px;
    font-weight: 600;
    color: #111111;
    margin: 0 0 6px;
  }

  .card-subtitle {
    font-size: 14px;
    color: #8a8a8a;
    margin: 0 0 28px;
  }

  .card-link {
    font-size: 14px;
    color: #6b6b6b;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
      padding-left: 4px;
    }

    &:hover {
      color: #111111;
    }
  }
`;

const Comp = () => {
  return (
    <StyledComp>
      <h2 className="heading serif">Deploy your financial data SDK on your preferred cloud</h2>
      <p className="subheading">
        Deploy AxionQuant's market data SDK through the cloud you already trust, with first-party
        support across the major platforms.
      </p>
      <div className="card-grid">
        {providers.map((provider) => (
          <div className="card" key={provider.name}>
            <img className="card-icon" src={provider.icon} alt={`${provider.subtitle} logo`} width="40" height="40" loading="lazy" />
            <h3 className="card-title">{provider.name}</h3>
            <p className="card-subtitle">{provider.subtitle}</p>
            <Link className="card-link" to={provider.href}>
              Deploy on {provider.cta} <ArrowUpRight width={14}/>
            </Link>
          </div>
        ))}
      </div>
    </StyledComp>
  );
};

export default Comp;
